








































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { SwTabGroup, SwTabPage } from '@libs/unified-ui-framework/src/shared/sw-tab-layout';
import { SwBarProgress } from '@libs/unified-ui-framework/src/shared/sw-progress';
import { SwCountryIcon } from '@libs/unified-ui-framework/src/shared/sw-country-icon';
import Map1 from '../../assets/India.png';
import { SwChartGaugeDonut, SwChartLine, SwChartCompareBar, CompareBarData, SwChartGaugeLollipop,
 GaugeLollipopValue, GaugeLollipopDatasetLabelFormatter } from '@libs/unified-ui-framework/src/shared/sw-chart';
import { SwTitlePane } from '@libs/unified-ui-framework/src/shared/sw-title-pane';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { CSSStyleOptions } from '@libs/unified-ui-framework/src/shared/common-types';
import { SwTextTab } from '../../components/sw-text-tab';
import SwGeoMapCanvas from '../../components/sw-geo-map-canvas.vue';
import SwGeoMapSvg  from '../../components/sw-geo-map-svg.vue';
import { SwCanvasMap }  from '../../components/sw-canvas-map';
import { SwDonutConcentric } from '../../components/sw-donut-concentric';
import Map from '../../assets/map_cas.svg';

const cssPrefix = 'sw-tab-page';

@Component({
  components: {
    SwGeoMapSvg,
    SwGeoMapCanvas,
    SwTabGroup,
    SwTabPage,
    SwBarProgress,
    SwCountryIcon,
    SwChartLine,
    SwTitlePane,
    SwChartCompareBar,
    SwIcon,
    SwTextTab,
    SwCanvasMap,
    SwDonutConcentric,
    SwChartGaugeDonut,
    SwChartGaugeLollipop,
  },
})
export default class SwTabPageComponent extends Vue {
  @Prop({ default () { return { }; } })
  dataSet: Chart.ChartDataSets[];

  @Prop({ default () { return { }; } })
  dataSet1: Chart.ChartDataSets[];

  @Prop({ default () { return { }; } })
  countryDataSet: Chart.ChartDataSets[];

  @Prop({ default: 1 })
  tabId: number;

  @Prop({ default () { return { }; } })
  compareData: CompareBarData;

  @Prop({ default: 'WorldWide' })
  regionName: string;

  @Prop({ default: '' })
  selectedLeftTabLabel: string;

  @Prop({ default: '' })
  toDate: string;

  @Prop({ default: '' })
  fromDate: string;

  @Prop({ default: false })
  doesNotHaveData: boolean;

  @Prop({ default: 0 })
  rotate:number;

  @Prop({ default: 0 })
  wwvalue: string|number;

  @Prop({ default: 0 })
  wwrotate:number;

  @Prop({ default: 0 })
  previous:number;

  @Prop({ default: 0 })
  present:number;

  @Prop()
  dataSetConc: GaugeLollipopValue[];

  @Prop()
  gaugeLabels: string[];

  @Prop({ default: [0, 0] })
  gauge: number[];

  @Prop({ default: false })
  waf: boolean;

  @Prop({ default() { return {}; } })
  compareBarConfig: Chart.ChartScales;

  cssPrefix = cssPrefix;
  theme: string = 'light';
  value2: number = 45;
  value1: number = 33;
  img = Map1;
  img1 = Map;
  themec = 'dark';
  display = false;
  // rotate: number = 0;
  val: number;
  rotate1: number = 180;
  selectedItem: number  = 1;
  labels = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  labelsToShow = ['JUN\'17', 'JUN\'18'];
  // dataSetConc = [{ data: [70, 30], label: 'Connections1', backgroundColor: 'transparent' },
  //           { data: [59, 41], label: 'Connections2', backgroundColor: 'transparent' }];
  // dataSet1: Chart.ChartDataSets[] = [{ data: [0.62,
  //   0.60,
  //   0.55,
  //   0.62,
  //   0.68,
  //   0.57,
  //   0.56,
  //   0.74,
  //   0.84,
  //   0.94,
  //   1.06,
  //   1.00], label: 'Trillions'
  // , backgroundColor: 'transparent',
  //   borderColor: '#47afe8' },
  // { data: [1.15,
  //   1.14,
  //   1.06,
  //   0.86,
  //   0.77,
  //   0.59,
  //   0.55,
  //   0.64,
  //   0.77], label: 'Trillions', backgroundColor: 'transparent', borderColor: '#ffcc00' }];
  // malwaresCompareData: CompareBarData = {
  //   categoryLabels: ['SEP\'17', 'SEP\'18'],
  //   dataset: [{
  //     data: [0.84, 0.77],
  //     label: '[trillion]',
  //   }],
  // };

  gaugeCpu: number = Number(this.gauge[0]);
  gaugeMemory: number = Number(this.gauge[1]);
  height: number = 0;
  width: number = 0;
  lollipopSingleFullCircle: boolean = true;
  barColorPalette: string[] = [
    '#63bae9',
    '#e0b63b',
    '#434343',
  ];
  barColorPaletteCrypto: string[] = [
    '#e0b63b',
    '#434343',
  ];
  barColorPaletteConc: string[] = [
    '#ffcc00',
    '#99cc00',
    '#9999ff',
  ];
  get gaugeOverriddenOptions() {
    return {
      layout: {
        padding: {
          left: 60,
          right: 20,
        },
      },
    };
  }
  get gaugeLabelFormatter(): GaugeLollipopDatasetLabelFormatter {
    return (label: string | undefined, data: number[]): string => {
      if (!label) { return ''; }
      return `${label}, ${data[0]}%`;
    };
  }
  // compareBarConfig = {
  //   xAxes: [{
  //     gridLines: {
  //       color: '#000000',
  //       display: false,
  //       drawBorder: false,
  //       drawOnChartArea: false,
  //     },
  //     ticks: {
  //       display: true,
  //       suggestedMin: 0,
  //     },
  //   }],
  //   yAxes: [{
  //     gridLines: {
  //       color: '#000000',
  //       drawBorder: false,
  //       display: false,
  //       drawOnChartArea: false,
  //     },
  //     ticks: {
  //       display: false,
  //       min: 0,
  //       suggestedMax: this.tabId === 1 && this.compareData.dataset[0] ? Math.max(...this.compareData.dataset[0].data) + 20 :
  //       (this.compareData.dataset[0] && this.compareData.dataset[1] ?
  //        Math.max(...this.compareData.dataset[0].data, ...this.compareData.dataset[1].data) + 20 : 20),
  //     },
  //   }],
  // };

  scaleConfig = {
    yAxes: [{
      gridLines: {
        display: false,
      },
      ticks: {
        min: 0,
      },
    }],
  };

  getVal(): Number {
    return this.tabId === 1 && this.compareData.dataset[0] ? Math.max(...this.compareData.dataset[0].data) + 20 :
        (this.compareData.dataset[0] && this.compareData.dataset[1] ?
         Math.max(...this.compareData.dataset[0].data, ...this.compareData.dataset[1].data) + 20 : 20);
  }
  get iconStyle(): CSSStyleOptions {
    return {
      color: this.rotate === 0 && this.tabId !== 3 ? '#CC0000' : '#99CC00',
    };
  }

  get iconStyle2(): CSSStyleOptions {
    return {
      color: this.wwrotate === 0 && this.tabId !== 3 ? '#CC0000' : '#99CC00',
    };
  }

  get iconStyle1(): CSSStyleOptions {
    return {
      color: this.tabId === 3 && this.compareData.dataset.length > 0 && (this.compareData.dataset[0].data[1] - this.compareData.dataset[0].data[0]) > 0 ?
       '#99CC00' : '#CC0000',
    };
  }

  get showHideLegend(): CSSStyleOptions {
    return {
      visibility: this.display ? 'visible' : 'hidden',
    };
  }

  get showHideIcon(): CSSStyleOptions {
    return {
      visibility: !this.display ? 'visible' : 'hidden',
      // tslint:disable-next-line:prefer-template
      left: (this.width - ((this.width > 1300 ? 0.225 : 0.24) * this.width) - (this.width / 14)) + 'px',
    };
  }
  onSelectRightTab() {
    // const wrapperElement : Node = ;
    this.display = this.display ? false : true;
    // const element1 = document.createElement('div');
    // element1.setAttribute('id', 'u190');
    // element1.setAttribute('class', 'ax_default  sw-flexbox sw-flexbox--start-items sw-flexbox--end-justify');
    // element1.appendChild(this.customizedRender());
    // if (!this.display) {
    //   element1.setAttribute('style', 'visibility: visible; cursor: pointer; width: auto; height: auto; outline: none;right: 0px;');
    // } else {
    //   element1.setAttribute('style', 'visibility: hidden; cursor: pointer; width: auto; height: auto; outline: none;right: 0px;');
    // }
    // document.body.appendChild(element1);
  }

  select() {
    this.display = this.display ? false : true;
  }

  onResize() {
    // this.worldMap.elHeight = 400;
    this.height = this.$el.clientHeight;
    this.width = this.$el.clientWidth;
  }

  get setHeight(): CSSStyleOptions {
    return {
      height : `${this.height}px`,
    };
  }

  get setWidth(): CSSStyleOptions {
    return {
      // tslint:disable-next-line:prefer-template
      width : (this.width < 1400 ? 42 : 25) + '%',
    };
  }

  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }
}
